// import CustomerInsightsModal from "src/components/CustomerInsightsModal/CustomerInsightsModal";

const GlobalModals = () => {
    return (
        <>
            {/* <CustomerInsightsModal /> */}
        </>
    );
};

export default GlobalModals;